import React, { useState } from 'react';
import { Row, Column } from 'react-foundation';

import Input from './Inputs';

const PasswordTab = () => {
	const [active, setActive] = useState(false);

	const toggle = () => {
		setActive(!active);
	};

	return (
		<div>
			<button className="accordion card" onClick={toggle}>
				<div className="account-card-title">Change password</div>
				<div className="account-card-text">
					Choose a unique password to protect your account
				</div>
				<div className="arrow-holder">
					<div className={active ? 'arrow active' : 'arrow'}></div>
				</div>
			</button>
			<div className={active ? 'dropdown active' : 'dropdown'}>
				<form>
					<div className="form-group">
						<Row>
							<Column small={12}>
								<Input inputType="current_password" />
							</Column>
						</Row>
						<Row>
							<Column small={12}>
								<Input inputType="password" />
							</Column>
						</Row>
						<Row>
							<Column small={12}>
								<Input inputType="password_confirmation" />
							</Column>
						</Row>
					</div>
					<Row>
						<Column small={12}>
							<div className="button-holder">
								<input
									type="submit"
									name="commit"
									className="primary-button long"
									data-disable-with="SAVE"
								/>
							</div>
							<p>Save</p>
						</Column>
					</Row>
				</form>
			</div>
		</div>
	);
};

export default PasswordTab;
